import { TpExpressionContext, evalExpression } from '../../../../components/safeExpressions';
import { get_guid } from '../../helpers/misc';
import { createDbActionVar_Value } from '../helpers/variables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

interface TpExpressionFunction {
  name: string;
  arguments: {
    name: string;
  }[];
  implementation: (argumentList: any[]) => any;
}

export const defaultExpressionFunctionsList: TpExpressionFunction[] = [
  {
    name: 'guid',
    arguments: [],
    implementation: (argumentList: any[]) => get_guid(),
  },
  {
    name: 'isEmpty',
    arguments: [{ name: 'arg' }],
    implementation: (argumentList: any[]) => !argumentList[0],
  },
];

export function addFunctionsToExpressionContext(expr: TpExpressionContext, functions: TpExpressionFunction[]) {
  if (!expr.functions) expr.functions = {};
  for (const func of functions) expr.functions[func.name] = func.implementation;
}

export function getExpressionFunctionsDescription(functions: TpExpressionFunction[]): string {
  return functions.map((func) => `${func.name}(${func.arguments.map((arg) => arg.name).join(', ')})`).join(', ');
}

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Calculate Variable',
    description: 'Creates a new variable by evaluating an expression.',
    properties: {
      type: { type: 'string', const: 'CalculateVariable' },
      id: {
        type: 'string',
        description: 'Identifier of the new variable to be created.',
      },
      expression: {
        type: 'string',
        description: `Expression to be evaluated. This can contain already existing variables, prefixed by a $ sign.
Special functions: ${getExpressionFunctionsDescription(defaultExpressionFunctionsList)}.`,
      },
    },
    required: ['type', 'id', 'expression'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const parameters: { [id: string]: any } = {};
  for (const variabName in ctx.variables) parameters['$' + variabName] = ctx.variables[variabName].content;
  const expr: TpExpressionContext = {
    expressionString: step.expression,
    parameters,
  };
  addFunctionsToExpressionContext(expr, defaultExpressionFunctionsList);
  const result = evalExpression(expr);
  createDbActionVar_Value(ctx, step.id, result);
  onCompleted();
}

const dbActionStepTypeCalculateVariable: TpDbActionStepTypeDefinition = {
  stepType: 'CalculateVariable',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeCalculateVariable;
